import {Unit} from "./unit";
import {bignumber} from "mathjs";

export interface TemperatureUnit extends Unit {

}

export const TemperatureUnitFahrenheit: TemperatureUnit = {
  roundingIncrement: bignumber("0.1")
}

export const TemperatureUnitCelsius: TemperatureUnit = {
  roundingIncrement: bignumber("0.05")
}
